<script>
export default {
  name: "BootstrapView"
};
</script>

<script setup>
import { onMounted } from "vue";
import { useRouter } from "vue-router";
import { useUserStore } from "@/stores/userStore";

const router = useRouter();
const userStore = useUserStore();

onMounted(async () => {
  if (!userStore.isSessionReady) {
    await userStore.initSession();
  }

  if (userStore.isAuthenticated) {
    router.replace("/home");
  } else {
    router.replace("/login");
  }
});
</script>

<template>
  <div style="height:100vh;display:flex;align-items:center;justify-content:center">
    <v-progress-circular indeterminate />
    <span style="margin-left:12px">Cargando sesión…</span>
  </div>
</template>
